import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { useInventoryDataStore } from '@/stores';
import {
  isInventoryPath,
  resolveInventoryTab,
  selectInventoryTab,
} from '@/features/inventory/router-helpers';

/**
 * Syncs the active inventory tab from the URL `?tab` on the `/inventory` route.
 *
 * URL is the source of truth (LR-447): with `?tab` absent the tab resets to
 * 'inventory', so a persisted 'availability' / 'counterparty-reports' from a
 * prior session cannot survive a logout + login or F5 and leave the visible tab
 * out of sync with the URL.
 *
 * Path + tab are read from the router store, the same source the view bootstrap
 * reads its guards from.
 */
export function useInventoryTabSync(): void {
  const setActiveTab = useInventoryDataStore((s) => s.setActiveInventoryTab);
  const routerPath = useRouterState({ select: (s) => s.location.pathname });
  const routerTab = useRouterState({ select: (s) => selectInventoryTab(s) });

  useEffect(() => {
    if (!isInventoryPath(routerPath)) return;
    setActiveTab(resolveInventoryTab(routerTab));
  }, [routerPath, routerTab, setActiveTab]);
}
